// eslint-disable-next-line import/no-anonymous-default-export
export default {
  loading: false,
  error: false,
  getBannerSettingListStatus: { data: null },
  getSalesByIdStatus: { data: null },
  getGeneralSettingListStatus: { data: null },
  getBillingSettingListStatus: { data: null },
  getFAQListStatus: { data: null },
};
